import * as React from 'react';
import axios from "axios";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import 'bootstrap/dist/css/bootstrap.css'; 
import Carousel from 'react-bootstrap/Carousel'; 

import ModalAppuntamento from "./ModalAppuntamento.js";

const HomeMenuPageComponent = ({ loginUserApiRequest,reduxDispatch, setReduxUserState  }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const config = require("../../constants/constants.js")

  const [page, setPage] = useState({});  
  const [id, setId] = useState("");                      
  const [title, setTitle] = useState("");                      
  const [subTitle, setSubTitle] = useState("");     
  const [description, setDescription] = useState("");     
  const [customizedName, setCustomizedName] = useState("");     
  const [customizedStreet, setCustomizedStreet] = useState("");     
  const [customizedZip, setCustomizedZip] = useState("");     
  const [customizedCity, setCustomizedCity] = useState("");     
  const [customizedEmail, setCustomizedEmail] = useState("");     
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage1, setPathImage1] = useState("");     
  const [pathImage2, setPathImage2] = useState("");     
  const [pathImage3, setPathImage3] = useState("");     
  const [titleImage1, setTitleImage1] = useState("");     
  const [subTitleImage1, setSubTitleImage1] = useState("");     
  const [titleImage2, setTitleImage2] = useState("");     
  const [subTitleImage2, setSubTitleImage2] = useState("");     
  const [titleImage3, setTitleImage3] = useState("");     
  const [subTitleImage3, setSubTitleImage3] = useState("");     
 
  const [isOpenTabAppuntamento, setIsOpenTabAppuntamento] = useState(false);

  const [cookiesPolicy, setCookiesPolicy] = useState("");

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =",menuValue);
    const url = `/api/pages/menuValue/`+menuValue;
    const { data } = await axios.get(url);
    console.log(`data =`, data);  
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('HOME').then((data) => { 
      console.log(`data 1 =`, data);  
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setPathImage1(data?.images[0].path);
      setPathImage2(data?.images[1].path);
      setPathImage3(data?.images[2].path);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setTitleImage1(data?.imagesTitle[0].text);
      setSubTitleImage1(data?.imagesSubTitle[0].text);
      setTitleImage2(data?.imagesTitle[1].text);
      setSubTitleImage2(data?.imagesSubTitle[1].text);
      setTitleImage3(data?.imagesTitle[2].text);
      setSubTitleImage3(data?.imagesSubTitle[2].text);
      console.log(`id =`, id);  
      console.log(`page?.title.text =`, page?.title.text);  
      console.log(`page?.description.text =`, page?.description.text);  
      console.log(`page?.customizedContent =`, page?.customizedContent);  
      console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);  
      console.log(`images =`, data?.images);  
      console.log(`images =`, data?.images[0].path);  
    })
    .catch((er) => {
      console.log(er);
    });  
  }, [tabAttivo,id])

  useEffect(() => {
    console.log('getItem(cookiesPolicy) = ',window.sessionStorage.getItem('cookiesPolicy')); 
    setCookiesPolicy(window.sessionStorage.getItem('cookiesPolicy'));
    if (typeof cookiesPolicy === "string") {     
      // già esiste
      console.log("La stringa è valorizzata");
    } else if (cookiesPolicy === null) {
      // null
      console.log("The string is null");
      window.sessionStorage.setItem('cookiesPolicy', JSON.stringify('attivo'));
      openModal();
    } else {
      // è ???
      console.log("La stringa è ???");
      openModal();
    }    
  }, [cookiesPolicy]);

  const openModal = () => {
    console.log(`opening modal, currently isOpenTabAppuntamento is == ${isOpenTabAppuntamento}`);
    setIsOpenTabAppuntamento(true);
  };

  const closeModalAppuntamento = () => {
    console.log(`closing modal, currently isOpenTabAppuntamento is == ${isOpenTabAppuntamento}`);
    setIsOpenTabAppuntamento(false);
  };

  const modalActionAppuntamento = () => {
    console.log("perform custom action with modal inputs...");
    closeModalAppuntamento();
  };

  const handleMouseDown = e => {
    e.preventDefault();
    console.log("background click");
  };
    
  return (

    <Container>
    
      <Row className="justify-content-md-center mt-5">

        <Col md={5}>

        <Carousel> 
          <Carousel.Item interval={2500}> 
            <img 
              className="d-block w-100"
              src={pathImage1}
              alt="immmagine del prodotto"
            /> 
            <Carousel.Caption> 
              <h3>{titleImage1}</h3> 
              <p>{subTitleImage1}</p> 
            </Carousel.Caption> 
          </Carousel.Item> 
          <Carousel.Item interval={2500}> 
            <img 
              className="d-block w-100"
              src={pathImage2}
              alt="immmagine del prodotto"
            /> 
            <Carousel.Caption> 
              <h3>{titleImage2}</h3> 
              <p>{subTitleImage2}</p> 
            </Carousel.Caption> 
          </Carousel.Item> 
          <Carousel.Item interval={2500}> 
            <img 
              className="d-block w-100"
              src={pathImage3}
              alt="immmagine del prodotto"
            /> 
            <Carousel.Caption> 
              <h3>{titleImage3}</h3> 
              <p>{subTitleImage3}</p> 
            </Carousel.Caption> 
          </Carousel.Item> 
        </Carousel> 
      </Col>

      <Col md={7}>

        <h1 
          style={{
            paddingTop: 8,
            paddingLeft: 8,
            paddingRight: 8,
            }}
        >
          {title}
        </h1>

        <Form.Group className="mb-3" controlId="validationCustom01" 
          style={{
            paddingLeft: 8,
            paddingRight: 8,
            }}
        >
          <Form.Label><em>&nbsp;{subTitle}</em></Form.Label>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicEmail"
          style={{
            paddingLeft: 8,
            paddingRight: 8,
            }}
        >
          <Form.Label>
            {description}
          </Form.Label>
        </Form.Group>

        <Form.Group>
            <Form.Label
                style={{
                    color: "#15497c",
                    marginLeft: "90px",
                }}
            >
            <b>{customizedName}</b></Form.Label>
          </Form.Group>
          <Form.Group>
            <Form.Label
                style={{
                  color: "#15497c",
                  marginLeft: "90px",
                }}
            >
            {customizedStreet}</Form.Label>
          </Form.Group>

          <Row className="justify-content-md-center">

              <Col md={1} className="justify-content-md-right">
              </Col>

              <Col md={8} className="justify-content-md-right">

                <Form.Group>
                  <Form.Label
                      style={{
                        color: "#15497c",
                        marginLeft: "0px",
                      }}
                  >
                    tel 035.90.40.14
                  </Form.Label>
                </Form.Group>
                <Form.Group>
                  <Form.Label
                      style={{
                        color: "#15497c",
                        marginLeft: "0px",
                      }}
                  >
                    cell 335.21.00.28
                  </Form.Label>
                </Form.Group>
                <Form.Group>
                  <Form.Label
                      style={{
                        color: "#15497c",
                        marginLeft: "0px",
                      }}
                  >
                    cell 339.534.13.45
                  </Form.Label>
                </Form.Group>
                <Form.Group>
                  <Form.Label
                      style={{
                        color: "#15497c",
                        marginLeft: "0px",
                      }}
                  >
                    cell 338.481.50.29
                  </Form.Label>
                </Form.Group>

                <Form.Group controlId="validationCustom01" >
                  <Form.Label
                        style={{
                          color: "#15497c",
                          marginLeft: "0px",
                        }}
                    >
                  romoloangelo@gmail.com</Form.Label>
                </Form.Group>

                </Col>

           </Row>

       </Col>
    </Row>
    
    <Row className="mt-5 justify-content-md-center">
      <Col md={12}>

      {isOpenTabAppuntamento && (
          <ModalAppuntamento
            id="modal"
            isOpenTabAppuntamento={isOpenTabAppuntamento}
            closeModal={closeModalAppuntamento}
            modalAction={modalActionAppuntamento}
            handleMouseDown={handleMouseDown}

            giorno={""}
            ora={""}
            riga={1}
            colonna={1}
            titoloRisorsa={""}
            cliente={""}
            categoria={""}
            prodotto={""}
            sito={""}
            durata={""}
            colore={""}
            owner={""}
            giornoAgenda={""}
            bookingData={""}
            bookingPrice={""}
            bookingCard={""}
          >
          </ModalAppuntamento>
        )}
      </Col>
    </Row>



  </Container>

  );
};

export default HomeMenuPageComponent;
